/**
 * Configurações específicas para o cliente "CAIXA"
 */
const settings: ClientSettings = {
  name: "Caixa Aqui",
  in100authority: "a CAIXA Aqui",
  downloadTermText: "A Caixa",
  theme: {
    token: {
      colorPrimary: "#005CA9",
    },
  },
  assets: {
    logo: "/logo.png",
    favicon: "/favicon.png",
    card: "",
    consignedCard: "",
    refinCard: "",
    bankLogo: "",
    userIcon: "/user-icon.png",
    bank_name: "",
  },
  cardExclusiveTheme: {
    name: "Cartão de Benefícios CAIXA",
    theme: {
      token: {
        colorPrimary: "#005CA9",
      },
    },
    assets: {
      logo: "/logo.png",
      favicon: "/favicon.png",
      bankLogo: "",
    },
  },
};

export default settings;
